
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M15 6.34c-4.773 0-8.66 3.887-8.66 8.66s3.887 8.66 8.66 8.66 8.66-3.887 8.66-8.66S19.772 6.34 15 6.34zm0 15.955c-4.023 0-7.295-3.272-7.295-7.295S10.977 7.705 15 7.705s7.295 3.272 7.295 7.295-3.272 7.295-7.295 7.295zM15 4.364c.41 0 .682-.273.682-.682V1.227c0-.409-.273-.682-.682-.682-.41 0-.682.273-.682.682V3.75c0 .34.273.614.682.614zM15 25.636c-.41 0-.682.273-.682.682v2.523c0 .409.273.682.682.682.41 0 .682-.273.682-.682v-2.523c0-.409-.273-.682-.682-.682zM6.545 7.5c.137.136.341.205.478.205.136 0 .34-.069.477-.205a.66.66 0 000-.955L5.727 4.773a.66.66 0 00-.954 0 .66.66 0 000 .954L6.545 7.5zM23.455 22.5a.66.66 0 00-.955 0 .66.66 0 000 .955l1.773 1.772c.136.137.34.205.477.205.136 0 .34-.068.477-.205a.66.66 0 000-.954L23.455 22.5zM3.682 14.318H1.227c-.409 0-.682.273-.682.682 0 .41.273.682.682.682H3.75c.41 0 .682-.273.682-.682 0-.41-.341-.682-.75-.682zM28.773 14.318H26.25c-.41 0-.682.273-.682.682 0 .41.273.682.682.682h2.523c.409 0 .682-.273.682-.682 0-.41-.273-.682-.682-.682zM6.545 22.5l-1.772 1.773a.66.66 0 000 .954c.136.137.34.205.477.205.136 0 .34-.068.477-.205L7.5 23.455a.66.66 0 000-.955.66.66 0 00-.955 0zM24.273 4.773L22.5 6.545a.66.66 0 000 .955c.136.136.34.205.477.205.137 0 .341-.069.478-.205l1.772-1.773a.66.66 0 000-.954.66.66 0 00-.954 0z"}}),_c('path',{attrs:{"d":"M13.09 16.09c0 .683-.408 1.092-.954 1.092-.545 0-1.022-.41-1.022-1.091V12.75H9.409v3.34c0 1.5 1.091 2.524 2.727 2.524 1.637 0 2.66-.955 2.66-2.523V12.75H13.09v3.34zM19.636 12.818l-1.363 3.955-1.296-3.955h-1.772l2.181 5.727h1.773l2.182-5.727z"}})])])
          )
        }
      }
    